import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { NavController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'pin-text-input',
  templateUrl: './pin-text-input.component.html',
  styleUrls: ['./pin-text-input.component.scss'],
})
export class PinTextInputComponent implements OnInit {

  @Input() pageTitle = '';
  @Input() showPinError = false;
  @Output() pinComplete: EventEmitter<string> = new EventEmitter<string>();
  @Input() redirectTo: string = '';
  pinForm: FormGroup;
  public errorMessages = {
    pin: [{
      type: 'required',
      message: ''
      },
      {
        type: 'minlength',
        message: ''
      },
      {
        type: 'maxlength',
        message: ''
      },
      {
        type: 'pattern',
        message: ''
      }
    ],
    confirmPin: [{
      type: 'required',
      message: ''
    }]
  };
  public pinType: string = 'password';
  public pinIcon: string = 'eye';
  public pinConfirmType: string = 'password';
  public pinConfirmIcon: string = 'eye';

  constructor(public formBuilder: FormBuilder,
              private nav: NavController,
              private translate: TranslateService) {
    this.pinForm = this.formBuilder.group({
      pin: new FormControl('', Validators.compose([
        Validators.required,
        Validators.pattern('^[0-9]+$'),
        Validators.minLength(6),
        Validators.maxLength(6)
        ])),
      confirmPin: new FormControl('', Validators.compose([
        Validators.required
    ])),
    }, {
      validators: this.pin.bind(this)
    });
  }

  async ngOnInit() {
    await this.setErrorMsg();
  }

  async setErrorMsg() {
    this.errorMessages = {
      pin: [{
        type: 'required',
        message: await this.translate.get('pin_input.error.required').toPromise()
      },
        {
          type: 'minlength',
          message: await this.translate.get('pin_input.error.min_length').toPromise()
        },
        {
          type: 'maxlength',
          message: await this.translate.get('pin_input.error.max_length').toPromise()
        },
        {
          type: 'pattern',
          message: await this.translate.get('pin_input.error.digits_only').toPromise()
        }
      ],
      confirmPin: [{
        type: 'required',
        message: await this.translate.get('pin_input.error.confirm_required').toPromise()
      }]
    };
  }

  pin(formGroup: FormGroup) {
    const { value: pin } = formGroup.get('pin');
    const { value: confirmPin } = formGroup.get('confirmPin');
    return pin === confirmPin ? null : { pinNotMatch: true };
  }

  submit() {
    this.pinComplete.emit(this.pinForm.value.pin);
  }

  handleTogglePin(confirm) {
    if (confirm) {
      this.pinConfirmType = this.pinConfirmType === 'password' ? 'text' : 'password';
      this.pinConfirmIcon = this.pinConfirmIcon === 'eye' ? 'eye-off' : 'eye';
    } else {
      this.pinType = this.pinType === 'password' ? 'text' : 'password';
      this.pinIcon = this.pinIcon === 'eye' ? 'eye-off' : 'eye';
    }
  }
  
  onBackButton() {
    this.redirectTo !== '' ? this.nav.navigateRoot(this.redirectTo, { replaceUrl: true, skipLocationChange: true }) : this.nav.back();
  }
}
